var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.RedpacketComponent,{tag:"component",attrs:{"send-redpack":_vm.props.sendRedpack,"is-preview":_vm.props.isPreview}})}
var staticRenderFns = []

export { render, staticRenderFns }